module.exports = __webpack_public_path__ + "img/20191002133249765.a6948c00.jpg";